const widths = {
  full: '100%',
  half: '50%',
  third: '33.33%',
  quarter: '25%',
  twoThirds: '66.67%',
  threeQuarters: '75%',
};

export default widths;